export default "__VITE_ASSET__jEB6$oJK__"